// extracted by mini-css-extract-plugin
module.exports = {"form":"style_form__36N86","address":"style_address__1p6rt","input":"style_input__1oy7V","twCitySelector":"style_twCitySelector__1eRve","street":"style_street__3LbLh"};